'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2;

import H5 from 'UIComponents/elements/headings/H5';
import ViewAllFeatures from '../product-pages/ViewAllFeatures';
import { getGAClassName } from 'pricing-pages-lib/utils/publicPageUrls';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBadge from 'UIComponents/badge/UIBadge';
import breakpoint from 'pricing-pages-unified-ui/utils/responsiveBreakpoints';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H1 from 'UIComponents/elements/headings/H1';
export const FormattedTitle = styled(H1).withConfig({
  displayName: "PlanPickerHeader__FormattedTitle",
  componentId: "sc-1bgp7vz-0"
})(["margin-bottom:0;"]);
export const FormattedCompactTitle = H5;
export const FormattedSubtitle = styled.div.withConfig({
  displayName: "PlanPickerHeader__FormattedSubtitle",
  componentId: "sc-1bgp7vz-1"
})(["margin-bottom:12px;", ""], breakpoint.phone(_t || (_t = _`
    display: none;
  `)));
const StyledFlex = styled(UIFlex).withConfig({
  displayName: "PlanPickerHeader__StyledFlex",
  componentId: "sc-1bgp7vz-2"
})(["", ""], breakpoint.phone(_t2 || (_t2 = _`
    flex-direction: column;
    align-items: start;
  `)));

const PlanPickerHeader = ({
  productLine,
  compact,
  isNew = false,
  trackingSource
}) => {
  const titleKey = compact ? `pricingPage.planBuilder.plansHeader.${productLine}.compactTitle` : `pricingPage.planBuilder.plansHeader.${productLine}.largeTitle`;
  return compact ? /*#__PURE__*/_jsx(FormattedCompactTitle, {
    className: "m-bottom-8",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: titleKey
    })
  }) : /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(StyledFlex, {
      align: "end",
      className: "m-bottom-3",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "align-center",
        children: [/*#__PURE__*/_jsx(FormattedTitle, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: titleKey
          })
        }), isNew && /*#__PURE__*/_jsx(UIBadge, {
          use: "new",
          className: "m-left-3",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricingPage.new"
          })
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "m-left-auto",
        children: /*#__PURE__*/_jsx(ViewAllFeatures, {
          trackingPrefix: "bundle",
          productLine: productLine,
          use: "inline",
          gaClassName: getGAClassName(`bundle-pricing-${productLine.toLowerCase()}compare`),
          trackingSource: trackingSource
        })
      })]
    }), /*#__PURE__*/_jsx(FormattedSubtitle, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `pricingPage.planBuilder.plansHeader.${productLine}.subtitle`
      })
    })]
  });
};

export default PlanPickerHeader;